/** @jsxImportSource @emotion/react */
import * as yup from "yup";
import { Modal } from "../../../components/Modal";
import { css } from "@emotion/react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ProductBarcode } from "../models/product";
import { TextField } from "../../../components/forms/fields/TextField";
import { ButtonAction } from "../../../components/NewButtons";
import { ActionSpinner } from "../../../components/ActionSpinner";

type Props = {
  isOpen: boolean;
  handleClose: () => void;
  onSubmit: (data: FormValues) => void;
};

type FormValues = ProductBarcode;

const schema = yup.object().shape({
  value: yup.string().required("Barcode is required"),
  type: yup.string().required("Type is required"),
});

const additionalFormStyles = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const BarcodeModal = ({ isOpen, handleClose, onSubmit }: Props) => {
  const methods = useForm<FormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      value: "",
      type: "EAN",
    },
  });
  const { ref, ...rest } = methods.register("value");

  const handleSubmit = (data: FormValues) => {
    onSubmit(data);
    handleClose();
    methods.reset();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        methods.reset();
        handleClose();
      }}
      header="Add barcode"
    >
      <div css={additionalFormStyles}>
        <TextField
          {...rest}
          innerRef={ref}
          errorMessage={
            methods.getFieldState("value", methods.formState).error?.message
          }
          label="Barcode"
          placeholder="Enter barcode"
        />
        <ButtonAction
          onClick={methods.handleSubmit(handleSubmit)}
          type="button"
          disabled={methods.formState.isSubmitting}
          width="100%"
        >
          {methods.formState.isSubmitting ? <ActionSpinner /> : "Add barcode"}
        </ButtonAction>
      </div>
    </Modal>
  );
};
